import { ICreateAndUpdateDriver } from "../../../types/driver.interface";
import customAxios from "../../customAxios";
import { CREATE_DRIVER, UPDATE_DRIVER } from "../../routes";
// import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const createDriver = async (props: ICreateAndUpdateDriver) => {
  const body = {
    ...props,
  };

  try {
    return (await customAxios.post(CREATE_DRIVER, body)).data;
  } catch (error: unknown) {
    console.error({ CREATE_DRIVER: error });
    return false;
  }
};

export default createDriver;
